import React from 'react';
import { Button, Modal, ButtonGroup, Heading } from '@landr/maestro';
import { usePurchaseControllerContext } from 'contexts/PurchaseControllerContext/PurchaseControllerContext';
import { Trans } from '@lingui/macro';
import { CONFIG } from 'utils/config';
import { ModalProps } from '../Modal.types';

interface PoorStandingOrSuspendedModalContentProps extends ModalProps {
    handleConfirm: () => void;
}

export const PoorStandingOrSuspendedModalContent: React.FC<
    PoorStandingOrSuspendedModalContentProps & {}
> = ({ handleClose, handleConfirm, isOpen }) => {
    return (
        <>
            <Modal.Content>
                <Modal.Section>
                    <Heading textStyle="lead">
                        <Trans>Please update your payment information</Trans>
                    </Heading>
                    <Trans>
                        There was a problem billing your account. Please update
                        your payment information to complete your purchase.
                    </Trans>
                </Modal.Section>
            </Modal.Content>
            <Modal.Footer>
                <ButtonGroup>
                    <Button
                        variant="secondary"
                        kind="minimal"
                        onClick={handleClose as () => void}
                    >
                        <Trans>Cancel</Trans>
                    </Button>

                    <Button variant="primary" onClick={handleConfirm}>
                        <Trans>Update now</Trans>
                    </Button>
                </ButtonGroup>
            </Modal.Footer>
        </>
    );
};

const PoorStandingOrSuspendedModal: React.FC<ModalProps> = ({
    isOpen,
    handleClose,
}) => {
    const { cancelPurchase } = usePurchaseControllerContext();

    const handleClosePoorStandingOrSuspendedModal = () => {
        handleClose();
        cancelPurchase();
    };

    const handleConfirm = () => {
        handleClose();
        cancelPurchase();
        window.open(`${CONFIG.VITE_ACCOUNT_BILLING_URL}`, '_blank');
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleClosePoorStandingOrSuspendedModal}
            size="sm"
        >
            <PoorStandingOrSuspendedModalContent
                handleClose={handleClosePoorStandingOrSuspendedModal}
                handleConfirm={handleConfirm}
                isOpen={isOpen}
            />
        </Modal>
    );
};

export default PoorStandingOrSuspendedModal;
